goog.provide("shadow.js.shim.module$$tiptap$extensions");
goog.provide("module$shadow_js_shim_module$$tiptap$extensions");
shadow.js.shim.module$$tiptap$extensions = shadow.js.nativeProvides["@tiptap/extensions"] = shadow$bridge("@tiptap/extensions");
module$shadow_js_shim_module$$tiptap$extensions.default = shadow.js.shim.module$$tiptap$extensions;
